import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import settings from '../../configs/settings.json'

const getPrimaryColor = () => {
  if (typeof window !== 'undefined') {
    return (window as any).catalog_config?.colors?.buttons || (settings as any).colors?.buttons || '#1565C0'
  }
  return (settings as any).colors?.buttons || '#1565C0'
}

export function CreateVuetifyApp(attachTarget?: HTMLElement | string) {
  return createVuetify({
    defaults: {
      global: {
        attach: attachTarget || '#app-root',
      },
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: getPrimaryColor(),
            secondary: '#5CBBF6',
          },
        },
      },
    },
  })
}

export default CreateVuetifyApp()
